import React, { useEffect, useRef, useState } from "react";
import Graph from "../ui/graph";
import { IREIGraphDataSet } from "../../interface/graph";

interface ScrollableGraphProps {
  id?: string;
  data: IREIGraphDataSet[];
  labels: string[];
  graphType: string;
  displayedYears: number;
  customOptions?: any;
  onYearChange: (year: number) => void;
  selectedYearIndex?: number;
}

const ScrollableGraph: React.FC<ScrollableGraphProps> = ({
  id,
  data,
  labels,
  graphType,
  displayedYears,
  customOptions,
  onYearChange,
  selectedYearIndex,
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const currentYearIndex = useRef<number>(0);
  const [slicedLabels, setSlicedLabels] = useState<string[]>([]);
  const [slicedDataSet, setSlicedDataSet] = useState<any[]>([]);
  const stepSize = 1;

  useEffect(() => {
    if (selectedYearIndex !== undefined) {
      setCurrentIndex(selectedYearIndex);
      currentYearIndex.current = selectedYearIndex;
    }
  }, [selectedYearIndex]);

  useEffect(() => {
    if (labels && labels.length > 0) {
      setSlicedDataSet((prev) =>
        data.map((dataset) => ({
          ...dataset,
          data: dataset.data.slice(currentYearIndex.current, currentYearIndex.current + displayedYears),
          backgroundColor: Array.isArray(dataset.backgroundColor)
            ? dataset.backgroundColor.slice(currentYearIndex.current, currentYearIndex.current + displayedYears)
            : dataset.backgroundColor,
          sliceStartIndex: currentYearIndex.current,
        }))
      );
    }
    if (labels && labels.length > 0) {
      setSlicedLabels((prev) => labels.slice(currentYearIndex.current, currentYearIndex.current + displayedYears));
    }
  }, [data, labels, currentIndex]);

  const nextYears = () => {
    if (currentYearIndex.current < labels.length - 1) {
      const newIndex = currentIndex + stepSize;
      setCurrentIndex(newIndex);
      currentYearIndex.current = newIndex;
      onYearChange(currentYearIndex.current);
    }
  };

  const prevYears = () => {
    if (currentYearIndex.current > 0) {
      const newIndex = currentIndex - stepSize;
      setCurrentIndex(newIndex);
      currentYearIndex.current = newIndex;
      onYearChange(currentYearIndex.current);
    }
  };

  return (
    <div className="" style={{ height: "350px" }}>
      <div className="pt-3 self-end">
        <Graph
          id={id}
          style={{ height: "300px", justifyContent: "end" }}
          labels={slicedLabels}
          dataSet={slicedDataSet}
          graphType={graphType}
          customOptions={customOptions}
          highlightIndex={true}
        />
      </div>
      <div className="flex justify-between px-4">
        <button
          id={id ? `${id}-btn-prev` : undefined}
          onClick={prevYears}
          disabled={currentIndex === 0}
          aria-label="Previous Year"
        >
          <i className="pi pi-angle-left text-lg align-middle" title="Previous Year"></i>
        </button>
        <button
          id={id ? `${id}-btn-next` : undefined}
          onClick={nextYears}
          disabled={currentIndex >= labels.length - 1}
          aria-label="Next Year"
        >
          <i className="pi pi-angle-right text-lg align-middle" title="Next Year"></i>
        </button>
      </div>
    </div>
  );
};

export default ScrollableGraph;
